import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, PageSize, StatusCodeActive } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { addSpaceEvery4, GetStatus } from "utils/helpers"
import { useModal } from "context/ModalContext";
import Pagination from "components/Input/PaginationButton";
import { FilterCard, PagesTitle } from "components/Cards";
import { CustomerService } from "services/CustomerService/CustomerService";
import GridDeleteButton from "components/Button/GridDeleteButton";
import GridEditButton from "components/Button/GridEditButton";
import DataTable from "components/DataTable";
import AddButton from "components/Button/AddButton";

export default function Customer(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerList, fetchDeleteCustomer } = CustomerService()

    const [customerList, setCustomerList] = useState([])
    const [customerName, setCustomerName] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "customerName",
            header: "Pelanggan"
        },
        {
            key: "phone",
            header: "No HP",
            render: (row) => addSpaceEvery4(row.phone),
        },
        {
            key: "email",
            header: "Email"
        },
        {
            key: "instagram",
            header: "Instagram"
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.customerId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.customerId, row.status)} size="w-3" />
                </div>
                
            ),
        },
    ]

    // Function Grid
    const handlePageChange = async (newIndex) => {
        showLoading()

        try {
            const res = await fetchCustomerList(customerName, status, PageSize, newIndex)
            if (!res) return
            
            const totalData = res?.data?.totalData ?? 0
            const total = Math.max(1, Math.ceil(totalData / PageSize))

            setCustomerList(res)
            setTotalPages(total)
            setPageIndex(newIndex)            
        } finally {
            hideLoading()
        }
    }
    
    // Button Event
    const addBtnClick = () => {
        navigate("/customer/form?customerId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/customer/form?customerId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = fetchDeleteCustomer(id, status)
            if (!res) return

            handlePageChange(pageIndex)
        }
        finally {
            hideLoading()
        }
    }

    useEffect(() => {
        handlePageChange(0)
    },[customerName, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Pelanggan' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Nama Pelanggan'>
                        <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value) }} />
                    </FilterCard>

                    <FilterCard title='Nama Pelanggan'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} text='Tambah Pelanggan' />
            </div>
           
            <div className="mt-5 hidden sm:block">
                <DataTable
                    columns={columns}
                    data={customerList?.data?.listData ?? []}
                />
            </div>

            <div className="sm:hidden mt-4 flex flex-col gap-3">
            {
                customerList?.data?.listData?.length === 0 ? (
                    <div className="text-center h-12">
                        <span>No Data Available</span> 
                    </div>
                ) :
                
                customerList?.data?.listData?.map((data, i) => {
                    return(
                        <div className="p-2 border rounded-lg hover:bg-slate-100" key={ i } onClick={() => {editBtnClick(data.expenseId)}}>
                            <div className="flex justify-between">
                                <span>#{data.rowNumber} </span>
                                <span>{}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>{data.customerName}</span>
                                <span></span>
                            </div>
                            <div className="flex justify-between">
                                <span>{data.phone}</span>
                                <span>{data.email}</span>
                            </div>
                        </div>
                    )
                })
            }
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}